// extracted by mini-css-extract-plugin
export default {"FormItem":"MappingFormItem_FormItem__WS5SX","Small":"MappingFormItem_Small__c+l5Q","LargeLabel":"MappingFormItem_LargeLabel__9eM00"};